import { forwardRef, type ReactNode } from "react";

import { cx } from "@/vnext/shared/cx";

import "@/vnext/shared/page-title/adminPageTitle.css";

export type AdminPageTitleProminence = "standard" | "prominent";

interface AdminPageTitleProps {
  actions?: ReactNode;
  className?: string;
  prominence?: AdminPageTitleProminence;
  subtitle?: string;
  title: string;
}

export const AdminPageTitle = forwardRef<HTMLDivElement, AdminPageTitleProps>(
  function AdminPageTitle(
    { actions, className, prominence = "standard", subtitle, title },
    ref,
  ) {
    return (
      <div
        className={cx(
          "admin-page-title",
          prominence === "prominent" && "admin-page-title--prominent",
          className,
        )}
        ref={ref}
      >
        <div className="admin-page-title__copy">
          <h1 className="admin-page-title__title">{title}</h1>
          {subtitle ? (
            <p className="admin-page-title__subtitle">{subtitle}</p>
          ) : null}
        </div>
        {actions ? (
          <div className="admin-page-title__actions">{actions}</div>
        ) : null}
      </div>
    );
  },
);
